// @flow
import _ from 'lodash'

const ADVERTISEMENT_HEADERS = [
  'impressions',
  'clicks',
  'ctr',
  'spent',
  'average_cpc',
  'average_cpm',
  'leads',
  'lead_percentage',
  'lead_price',
  'reached_users'
]
const METRIC_HEADERS = [
  'counter_impressions',
  'goals',
  'goal_percentage',
  'goal_price',
  'total_revenue',
  'transactions',
  'transaction_price',
  'drr'
]
const SENLER_HEADERS = [
  'subscribed',
  'unsubscribed',
  'cps',
  'unsubscribed_percentage',
  'active_subscribed',
  'active_cps'
]
const FACEBOOK_HEADERS = [
  'conversions',
  'conversion_price',
  'conversion_percentage',
  'conversion_rate_ranking',
  'engagement_rate_ranking',
  'quality_ranking'
]
const SMM_HEADERS = [
  'group_visits',
  'group_joins',
  'group_joins_percentage',
  'group_joins_price',
  'likes'
]
const COMMON_HEADERS = [
  'budget',
  'payment',
  'users',
  'placement_type',
  'providers_list',
  'platform',
  'fb_placements',
  'vk_placement',
  'locations',
  'sex',
  'age',
  'interests',
  'demographics',
  'total_limit',
  'cpc_effective',
  'cpm_effective'
]

export type GroupedHeaders = {|
  common: Array<string>,
  advertisement: Array<string>,
  senler: Array<string>,
  fb: Array<string>,
  smm: Array<string>,
  metric: Array<string>
|}

export function groupHeaders(headers: Array<string>): GroupedHeaders {
  return {
    common: _.intersection(headers, COMMON_HEADERS),
    advertisement: _.intersection(headers, ADVERTISEMENT_HEADERS),
    senler: _.intersection(headers, SENLER_HEADERS),
    fb: _.intersection(headers, FACEBOOK_HEADERS),
    smm: _.intersection(headers, SMM_HEADERS),
    metric: _.intersection(headers, METRIC_HEADERS)
  }
}

export function onlyStatisticHeaders(): Array<string> {
  const statisticHeaders = _.concat(
    ADVERTISEMENT_HEADERS,
    METRIC_HEADERS,
    SENLER_HEADERS,
    FACEBOOK_HEADERS,
    SMM_HEADERS
  )
  return _.flatten(statisticHeaders)
}
